import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { GeographicEntityForm } from '@/components/geographic/GeographicEntityForm'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { geographicEntities } from '@/config/geographicEntities'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditGeographicRegionPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams()
  const config = geographicEntities.geographicRegions

  return (
    <AdminLayout>
      <Box p={4}>
        <Card>
          <CardHeader>
            <Heading size="md">Edit {config.singular}</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>Update PH region details</Text>
          </CardHeader>
          <CardBody>
            <GeographicEntityForm config={config} entityId={id ? Number(id) : undefined} onSuccess={() => navigate(config.basePath)} onCancel={() => navigate(config.basePath)} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
